// extracted by mini-css-extract-plugin
export default {"primary":"#4c6b93","secondary":"#537aa0","dark":"#072f65","light":"#86add3","borderWidth":"1px","borderColor":"#dee2e6","inputFocusBoxShadow":"0 0 0 .25rem rgba(76,107,147,.25)"};